// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__AdCvD","titleWrap":"styles_titleWrap__yEmf1","wrapRight":"styles_wrapRight__PH-+b","rowWrap":"styles_rowWrap__UHJ2Q"};